import { render, staticRenderFns } from "./morePanel.vue?vue&type=template&id=66107d43&scoped=true&"
import script from "./morePanel.vue?vue&type=script&lang=js&"
export * from "./morePanel.vue?vue&type=script&lang=js&"
import style0 from "./morePanel.vue?vue&type=style&index=0&id=66107d43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66107d43",
  null
  
)

export default component.exports